import React from 'react';
import classNames from 'classnames';
import { CircleX, CircleCheck, AlertTriangle, Info } from 'lucide-react';

/*
 * Four tones, all on palette tokens. `warning` is the accent (there is no separate amber in
 * this product) and `info` is deliberately NEUTRAL: the blue it used to be was the only blue
 * in the app, so an informational note shouted louder than a real warning next to it.
 */
const ALERT_CONFIG = {
  danger: {
    styles: 'text-ui-danger bg-ui-danger-wash border-ui-danger-edge',
    icon: CircleX,
  },
  success: {
    styles: 'text-ui-success bg-ui-success-wash border-ui-success-edge',
    icon: CircleCheck,
  },
  warning: {
    styles: 'text-ui-accent bg-ui-accent-wash border-ui-accent-edge',
    icon: AlertTriangle,
  },
  info: {
    styles: 'text-ui-2 bg-ui-overlay border-ui-hair-2',
    icon: Info,
  },
};

export const Alert = ({ className, type = 'info', role, children }) => {
  const config = ALERT_CONFIG[type] || ALERT_CONFIG.info;
  const Icon = config.icon;

  return (
    <div role={role ?? (type === 'danger' ? 'alert' : 'status')} className={classNames('rounded-row border p-3 text-[13px]', config.styles, className)}>
      <div className="flex items-start gap-2.5">
        <Icon size={16} className="mt-px flex-none" />
        <div className="flex-1 leading-relaxed">{children}</div>
      </div>
    </div>
  );
};
